import { render, staticRenderFns } from "./DeButton.vue?vue&type=template&id=db723efa&scoped=true&"
import script from "./DeButton.vue?vue&type=script&lang=js&"
export * from "./DeButton.vue?vue&type=script&lang=js&"
import style0 from "./DeButton.vue?vue&type=style&index=0&id=db723efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db723efa",
  null
  
)

export default component.exports